import { authApi } from '..';
import { AuthForgotPasswordDto, InviteRetailerDto, RefreshTokenDto } from "./dto";

export async function refreshTokenRequest() : Promise<RefreshTokenDto> {
  return await authApi.get<RefreshTokenDto>('/refresh-token');
}

export function forgotPassword(email: string) {
  return authApi.post('/forgot-password', { email });
}


export async function inviteEmployer(data: AuthForgotPasswordDto) {
  return await authApi.post('/invite/employer', data);
}

export async function inviteRetailer(data: InviteRetailerDto) {
  return await authApi.post('/invite/retailer', data);
}
